/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import styles from './BoardTags.module.scss';

BoardTags.propTypes = {
  onTagClick: PropTypes.func.isRequired,
  tags: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
  })).isRequired,
};

const CONTRACTED_AMOUNT = 7;

export default function BoardTags({ onTagClick, tags }) {
  const [expanded, setExpanded] = useState(false);

  if (!tags || !tags.length) {
    return null;
  }

  const renderTags = expanded ? tags : tags.slice(0, CONTRACTED_AMOUNT);

  const tagComponents = renderTags.map((tag, index) => {
    return (
      <div
        className={ `${styles.Pill} ${styles.Tag}` }
        key={ tag.id }
        onClick={ () => onTagClick(tag, index) }
      >
        <div className={ styles.PillText }>
          {tag.title}
        </div>
      </div>
    );
  });

  return (
    <div className={ `${styles.TagContainer} ${expanded ? styles.Expanded : ''}` }>
      {tagComponents}
      {
        (tags.length > CONTRACTED_AMOUNT) && (
          <div
            className={ `${styles.Pill} ${styles.Expand}` }
            onClick={ () => setExpanded(!expanded) }
          >
            <div className={ styles.PillText }>
              {expanded ? 'View Less' : `+ ${tags.length - renderTags.length} more`}
            </div>
          </div>
        )
      }
    </div>
  );
}
